module.exports = {"id":"204078","name":"Rafał Wolski","rating":"73","photo":"./data/images/photos/1/204078.png","club":{"name":"Lechia Gdańsk","logo":"./data/images/clubs/LechiaGdansk.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RafałWolski0.json
// module id = 3516
// module chunks = 0